import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StarResponse } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class backendService {
  
  private httpClient:                                         HttpClient = inject(HttpClient);

  public testbackendService():Observable<StarResponse>{

    return this.httpClient.get<StarResponse>(`${environment.backendService.url}stars`);
  }
}
